<div style="align-items: center;">
    <div class="modal-heading">
        <div class="close-button invisible"></div>
        <div class="header-section">
            <span class="header-text">Trace Details </span>
        </div>
        <div class="close-button" (click)="closeDialog()">
            <mat-icon class="close-icon">close</mat-icon>
        </div>
    </div>

    <div class="info-card">

        <div class="row">
            
            <div class="col col-sm-12">
                <label>Name</label>
                <p>{{ traceDetails.firstName }} {{ traceDetails.lastName }}</p>
            </div>
        </div>

        <div class="row">
            <div class="col col-sm-6">
                <label>Email</label>
                <p>{{ traceDetails.email }}</p>
            </div>

            <div class="col col-sm-6">
                <label>Contact No</label>
                <p>{{ traceDetails.contactNo }}</p>
            </div>
        </div>

        <div class="row">
            <div class="col col-sm-6">
                <label>Updated Date</label>
                <p>{{ traceDetails.updatedAt | date : 'dd-MM-yyyy' }}</p>
            </div>

            <div class="col col-sm-6">
                <label>Uploaded File Name</label>
                <p>{{ traceDetails.refDocPath }}</p>
            </div>
        </div>

        <div class="row">
            <div class="col col-sm-12">
                <label>Comment</label>
                <p>{{ traceDetails.comment }}</p>
            </div>
        </div>

    </div>

    <!-- <div class="table-container">

        <table class="table">

            <thead class="table-head">
                <tr>
                    <th>
                        <span>ID</span>
                    </th>
                    <th>
                        <span>Name</span>
                    </th>
                    <th>
                        <span>Email</span>
                    </th>
                    <th>
                        <span>Contact No</span>
                    </th>
                    <th>
                        <span>Status</span>
                    </th>
                    <th>
                        <span>File Name</span>
                    </th>
                    <th>
                        <span>Updated Date</span>
                    </th>
                    <th>
                        <span>Comment</span>
                    </th>
                </tr>
            </thead>

            <tbody class="table-body">
                <tr>
                    <td data-label="id">
                        {{traceDetails.id}}
                    </td>
                    <td data-label="name">
                        {{traceDetails.firstName}} {{traceDetails.middleName}} {{traceDetails.lastName}}
                    </td>
                    <td data-label="email">
                        {{traceDetails.email}}
                    </td>
                    <td data-label="contactNo">
                        {{traceDetails.contactNo}}
                    </td>
                    <td data-label="status">
                        {{traceDetails.status}}
                    </td>
                    <td data-label="file">
                        {{traceDetails.refDocPath}}
                    </td>
                    <td data-label="update date">
                        {{traceDetails.updatedAt|date:'dd/MM/yyyy'}}
                    </td>
                    <td data-label="comment">
                        {{traceDetails.comment}}
                    </td>
                </tr>

            </tbody>
        </table>
    </div> -->
</div>